import React, { useEffect, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';

import { VisitorsTable } from '../components/VisitorsTable';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { VisitorsProps } from '../service/visitors.interface';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { FETCH_DELAY } from '../../../utils/common';
import { TableTitle } from '../../../views/Common/TableTitle';
import { ExportsButton } from '../../exports/components/ExportsButton';
import { useAppSelector } from '../../../../../store';
import { useLazyReadVisitorsQuery } from '../service/visitors.api';

export const VisitorsContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        CommonFiltersProps,
        VisitorsProps
    >(useLazyReadVisitorsQuery, {});

    const current = useAppSelector(selectShopCurrent);

    const tableProps = useMemo<
        CommonTableProps<VisitorsProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (current?.id) {
                get({ filters: filters, id: current.id }, true);
            }
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get, current?.id, filters]);

    return (
        <Flex gap={24} vertical>
            <TableTitle title={'История посетителей'}>
                <ExportsButton />
            </TableTitle>

            <VisitorsTable {...tableProps} />

            <Outlet />
        </Flex>
    );
};
